import { SummaryActionResult } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { SUMMARY_CONTROL_BASE_PATH } from '../constants/summaryControlBasePath';

export const postSummaryControlAction = async (
  constructPost: ConstructPost,
  definitionName: string,
  controlId: string,
  documentId: string,
): Promise<NonPaginatedResponse<SummaryActionResult> | undefined> =>
  constructPost(
    `${SUMMARY_CONTROL_BASE_PATH}/${controlId}`,
    {
      data: { documentId },
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
      },
    },
    { preventDefaultErrorToast: true },
  );
